<template>
  <div class="being-matched">
    <!-- <div class="header">
      <div class="left">
        <span>{{ timeLeft }}</span>
      </div>
      <SettingVue></SettingVue>
    </div> -->
    <div class="content no-scrollbar">
      <div class="user-box">
        <div class="item" v-for="(user, index) of userList" :key="index">
          <img
            class="avatar"
            :src="user.avatar"
            alt=""
            @click="toPlayerDetail(user)"
          />
          <div class="name">
            {{ user.isOpen ? user.name : user.userUuid === uuid ? '我' : '匿名' }}
          </div>
          <div class="status">
            <img
              class="icon-open"
              src="./images/icon-open.png"
              alt=""
              v-if="user.isOpen"
            />{{ user.isOpen ? '資料已公開' : '資料未公開' }}
          </div>
          <div class="score">
            <img src="./images/icon-gift.png" alt="" srcset="" />
            <span>{{ user.score }}</span>
          </div>
        </div>
      </div>
      <div class="end">通話結束</div>
      <button class="btn-retry" type="button" @click="retry()">
        發起新的通話
      </button>
    </div>
  </div>
</template>
<script>
// import SettingVue from './setting.vue';
import AnonymousCallProvider from './anonymousCall';
export default {
  name: 'PhoneEnding',
  components: {
    // SettingVue
  },
  data() {
    return {
      AnonymousCallProvider,
      timeLeft: '5:00',
      timer: null
    };
  },
  watch: {},
  computed: {
    user1() {
      return this.AnonymousCallProvider.user1;
    },
    user2() {
      return this.AnonymousCallProvider.user2;
    },
    userList() {
      return [this.user1, this.user2];
    }
  },
  methods: {
    toPlayerDetail(user) {
      if (user.isOpen) {
        this.$router.push({
          path: `/player-detail/${user.userUuid}`
        });
      }
    },
    retry() {
      this.$emit('retry');
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.being-matched {
  color: white;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
  line-height: 1.5;
  position: relative;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 120px;
    flex: none;
    position: relative;
    width: 100%;
    padding: 0 24px;
  }
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.55);
    /deep/ .el-popover__reference-wrapper {
      display: flex;
      align-items: center;
    }
    .time-box {
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 21px;
      img {
        width: 17px;
        height: auto;
        margin-right: 6px;
      }
    }
    .red-beg {
      width: 21px;
      height: auto;
      margin-left: 5px;
    }
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: auto;
    height: 1px;
    overflow: auto;
  }
  .user-box {
    display: flex;
    justify-content: space-around;
    width: 100%;
    flex: none;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .avatar {
        background: #d9d9d9;
        border-radius: 1197.19px;
        width: 112px;
        height: 112px;
        border-radius: 50%;
        object-fit: cover;
        margin-bottom: 25px;
        cursor: pointer;
      }
      .name {
        font-size: 18px;
      }
      .status {
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.55);
        font-size: 15px;
        margin-top: 4px;
        .icon-open {
          width: 17px;
          height: auto;
        }
      }
      .score {
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.55);
        font-size: 13px;
        background: rgba(255, 255, 255, 0.07);
        border-radius: 1197.19px;
        padding: 0 8px;
        height: 20px;
        justify-content: center;
        line-height: 1;
        font-size: 13px;
        margin-top: 8px;
        img {
          width: 13px;
          height: auto;
          margin-right: 1px;
        }
      }
    }
  }
  .end {
    color: rgba(255, 255, 255, 0.77);
    font-size: 16px;
    padding-top: 100px;
    margin-bottom: 80px;
  }

  .btn-retry {
    border-radius: 1197.19px;
    border-style: solid;
    border-color: rgba(255, 255, 255, 0.35);
    border-width: 2.4px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    height: 44px;
    color: rgba(255, 255, 255, 0.77);
    margin-bottom: 40px;
    flex: none;
  }
}
</style>
<style lang="scss">
.on-phone-popover {
  color: rgba(255, 255, 255, 0.77) !important;
  background: rgba(255, 255, 255, 0.07);
  border-radius: 8.39px;
  border: none;
  .phone-info {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.77);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .price {
      color: #111111;
      background: #ffcb46;
      border-radius: 1197.19px;
      padding: 3.6px 8.39px 3.6px 8.39px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
  .popper__arrow,
  .popper__arrow::after {
    border-bottom-color: rgba(255, 255, 255, 0.07) !important;
  }
}
</style>
